angular.module('app').directive('typableDropdown', [
    'SpotifyService',
    function (SpotifyService) {
        return {
            restrict: 'E',
            scope: {
                placeholder: '@', // Placeholder text for the input
                searchQuery: '='
            },
            template: `
            <md-input-container class="md-block col-xs-6">
                <div class="typable-dropdown">
                    <input type="text"
                        ng-model="searchQuery"
                        placeholder="Search for a track"
                        ng-blur="onBlur()"/>

                    <ul ng-show="showDropdown" class="dropdown-list">
                        <li ng-repeat="track in trackResults" ng-click="selectTrack(track)">
                            <img ng-src="{{track.image}}" alt="{{track.artist}}" width="30" height="30" />
                            {{track.album}} - {{track.artist}}
                        </li>
                    </ul>
                </div>
            </md-input-container>
            <md-input-container class="col-xs-2 m-0" style="padding: 0">
                <md-button class="md-raised button-icon" ng-click="searchTracks()" >
                    <i class="fa fa-search"></i>                                        
                    <md-tooltip md-delay="200" md-direction="top">Search for a track on spotify</md-tooltip>
                </md-button>
            </md-input-container>
        `,
            link: function (scope) {
                scope.searchQuery = '';
                scope.trackResults = [];
                scope.showDropdown = false;

                scope.searchTracks = function () {
                    if (scope.searchQuery.length > 0) {
                        SpotifyService.fetchTrack(scope.searchQuery).then(function (results) {
                            scope.$applyAsync(() => {
                                scope.trackResults = results;
                                scope.showDropdown = results.length > 0;
                            });
                        });
                    } else {
                        scope.trackResults = [];
                        scope.showDropdown = false;
                    }
                };

                scope.loadImageIntoPlaceholder = function (spotifyElement, URL, canvas) {
                    const img = new Image();
                    img.onload = function () {
                        spotifyElement.setElement(img);
                        canvas.renderAll();
                    };
                    img.onerror = function (e) {
                        console.error(e);
                    };
                    img.crossOrigin = 'Anonymous';
                    img.src = URL;
                };

                scope.selectTrack = function (track) {
                    const $scope = scope.$parent;
                    const parentGroupId = $scope.canvas.getActiveObject().groupId || $scope.groupsSelected[0].id;
                    scope.searchQuery = track.name;
                    scope.showDropdown = false;
                    const spotifyGroup = $scope.canvas
                        .getObjects()
                        .filter((obj) => obj.type === 'group' && obj.groupId === parentGroupId);
                    spotifyGroup.trackName = track.name;
                    const spotifyElements = $scope.canvas.getObjects().filter((obj) => obj.groupId === parentGroupId);
                    spotifyElements.forEach((spotifyElement) => {
                        if (spotifyElement.type === 'image-placeholder') {
                            let imageToLoad = track.image;
                            if (spotifyElement.imageMode == 'single color') {
                                imageToLoad = track.scanableImg;
                            }
                            scope.loadImageIntoPlaceholder(spotifyElement, imageToLoad, $scope.canvas);
                        }

                        if (spotifyElement.type === 'bounded-text') {
                            let textToUpdate = track.name;
                            if (spotifyElement.getOutlineWidth() == 0) {
                                textToUpdate = track.artist;
                            }
                            $scope.updateText(textToUpdate, spotifyElement);
                        }

                        if (spotifyElement.type == 'vector-placeholder' && spotifyElement.qrConfig) {
                            const link = track.link || 'www.customily.com';
                            const newConfig = { ...spotifyElement.qrConfig, text: link };
                            spotifyElement.qrConfig = newConfig;
                            $scope.displayQrWithConfig(newConfig, spotifyElement);
                        }
                    });
                };
            }
        };
    }
]);
